export class Listener {
    chatEnd(eventId) { }
    chatStart(eventId) { }
    formNavigate(eventId, formName, formStep, navigationAction, data) { }
    formStart(eventId, formName, inputName) { }
    formSubmit(eventId, formName, data) { }
    formSubmitResult(eventId, formName, submitData, statusCode, responseData) { }
    setConsent(eventId, essential, functional, marketing) { }
    setCustomer(eventId) { }
    setExperimentVariation(eventId, experiment, variation) { }
    pageReady(eventId) { }
    scrollDistance(eventId, from, fromPercent, to, toPercent, distance, distancePercent, direction, duration, numEvent) { }
    scrollPercentage(eventId, percent) { }
    softConversion(eventId, source) { }
    phoneClick(eventId, number, location, elementPath) { }
    customEvent(eventId, name, data = {}) { }
}
